import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './login.css';
import '../index.css';
import axios from 'axios';
import ChangePassSuccess from './ChangePassSuccess';


export class ChangePass extends Component {

  state = {
    old_password: '',
    new_password: '',
    new_password2: '',
    success: false,
    message: '',
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
  };

  setSuccessMessage(message) { this.setState({ message : message}); setTimeout(() => {this.setState({message: ''});}, 3000)
}

  onSubmit = (e) => {
    e.preventDefault();this.state.new_password === this.state.new_password2? this.changePass(this.state.old_password, this.state.new_password) : this.setSuccessMessage('Konfirmasi Password Baru Tidak Sesuai !')
  };
 
  changePass = (old_password, new_password) => { 
    const body = JSON.stringify({ old_password, new_password });const {token} = this.props.auth;const config = { headers: { 'Content-Type': 'application/json',},};if (token) {config.headers['Authorization'] = `Token ${token}`;}
    axios.put('https://liwat-id-backend.herokuapp.com/api/change-password/', body, config).then((res) => {this.setState({success : true})}).catch((err) => {this.setState({success : false});this.setSuccessMessage('Password Lama Salah !')})
};


  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { old_password, new_password, new_password2, message } = this.state;
    return (

        <div>
            {this.state.success?
            <ChangePassSuccess /> 
        
        :
            <div className="container-sm sign-in-form-container ">
            <div className="d-flex justify-content-center sign-in-title">
                <p className="headline">Ubah Password</p>
            </div>
            <div className="d-flex justify-content-center">
              <form onSubmit={this.onSubmit} data-testid="change-pass">
                <div className="mb-4 text-start">
                    <label className="form-label body">Password Lama</label>
                    <input 
                    type="password" 
                    name="old_password" 
                    className="form-control field" 
                    data-testid="input-old-password" 
                    onChange={this.onChange}
                    value={old_password}
                    required
                    />
                </div>
  
                <div className="mb-4 text-start">
                    <label className="form-label body">Password Baru</label>
                    <input 
                    type="password" 
                    name="new_password" 
                    className="form-control field" 
                    data-testid="input-newpassword" 
                    onChange={this.onChange}
                    value={new_password}
                    required
                    />
                </div>

                <div className="mb-5 text-start">
                    <label className="form-label body">Konfirmasi Password Baru</label>
                    <input 
                    type="password" 
                    name="new_password2" 
                    className="form-control field" 
                    data-testid="input-newpassword2" 
                    onChange={this.onChange}
                    value={new_password2}
                    required
                    />
                </div>

                <div className="d-flex justify-content-center">
                      <p className="h6 red">{message}</p>
                </div>
  
                <div className="d-flex justify-content-center">
                    <button data-testid="submit" type="submit" className="button button-login ">
                      Konfirmasi
                    </button>
                </div>
              </form>
              </div>   
      </div>
        
       
    }

</div>

         
    );
  }
}

const mapStateToProps = (state) => ({
    auth: state.auth
  });

  export default connect(mapStateToProps)(ChangePass);